// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { useIsMobile } from '@tectonics/hooks';

import { Separator } from '../../../../../volcanes/atoms/separator';

import { DisplayTotalAmount } from '../../boleto/page-content/display-total-amount';
import { DisplayExpiration } from './display-expiration';
import { QRCodeDesktop } from './qr-code-desktop';
import { QRCodeMobile } from './qr-code-mobile';

export function Ticket(): Node {
  const QRCode = useIsMobile() ? QRCodeMobile : QRCodeDesktop;

  return (
    <Root>
      <PaymentInfoWrapper>
        <DisplayTotalAmount />
        <DisplayExpiration />
      </PaymentInfoWrapper>
      <Separator pattern="dashed" direction="vertical" size={5.5} />
      <Title>Pague com Pix</Title>
      <Subtitle>Use o app do seu banco ou carteira digital para escanear o código QR abaixo:</Subtitle>
      <QRCode />
    </Root>);
}

const Title = styled.div `
  font-family: Gilroy, "Open Sans", "OpenSans", Arial, "Helvetica Neue", Helvetica, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  text-align: center;
  color: #738093;
  margin-bottom: 13px;
`;

const Subtitle = styled.div `
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  margin-bottom: 12px;
  max-width: 345px;
  color: #666666;
`;

const Root = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PaymentInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 15px;
  background: #f8f8f9;
  width: 100%;
`;
